const styles = (theme) => ({
  dataGrid: {
    minHeight: 150,
    height: 180,
    maxHeight: 240,
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    "&>.gridTheme-light>.ag-theme-material.theme-light, &>.gridTheme-dark>.ag-theme-material.theme-dark":
      {
        height: "100%",
      },
    "& .statusBar": {
      display: "none",
    },
  },
  iconStyle: {
    float: "right",
    color: theme.iconColor,
    cursor: "pointer",
  },
  headerStyle: {
    border: `1px solid ${theme.AppBGColor}`,
    padding: "12px",
    borderRadius: "4px 4px 0 0",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  GridFooter: {
    border: `1px solid ${theme.AppBGColor}`,
    padding: "0px 24px",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    height: "35px",
    display: "flex",
    alignItems: "center",
  },
  GridPanel: {
    border: `1px solid ${theme.AppBGColor}`,
    padding: "5px 24px",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    display: "flex",
    alignItems: "center",
    maxHeight: "100px",
    overflowY: "auto",
  },
  label: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
    color: theme.dispatchPanelHeaderColor,
    marginRight: 4,
  },
  value: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    color: theme.TextColor,
    paddingRight: 40
  },
});

export default styles;
